import type { ComponentProps, PropsWithChildren } from 'react';
import { Children } from 'react';
import { Column, Row } from './box';
import { Text } from './text';

export function OrderedList({ children }: PropsWithChildren) {
  return (
    <Column gap="spacing.general.x4">
      {Children.map(children, (child, index) => (
        <Row>
          <Text marginRight="spacing.general.x2" variant="bodyBase">
            {index + 1})
          </Text>
          {child}
        </Row>
      ))}
    </Column>
  );
}

OrderedList.Point = function BulletPoint({ children, ...rest }: Omit<ComponentProps<typeof Text>, 'variant'>) {
  return (
    <Text variant="bodyBase" {...rest}>
      {children}
    </Text>
  );
};
